// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../variables.css\"","mobile-threshold-width":"610px","checkbox":"componentsForPicker_checkbox__1Ldan","label":"componentsForPicker_label__2qE2I"};